import { createFileRoute } from '@tanstack/react-router'
import UserOverview from 'User/components/Sections/UserOverview'

export const Route = createFileRoute('/user/$userId/')({
    component: UserOverview,
})
